module.exports = __webpack_public_path__ + "img/micromall_backstage2.340352ea.png";